// /src/router下index.js
import { module } from "./module/index";
import VueRouter from "vue-router";
import Vue from "vue";

// 使用VueRouter
Vue.use(VueRouter);

const routes = [...module];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});


// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  // NProgress.start()
  Vue.prototype.$routeParams = { id: to.query.id,scene:to.query.scene }
  // let lang = localStorage.getItem('language')
  // if (lang === 'zh' || lang === 'zh-CN') {
  //   localStorage.setItem('language', 'zh-CN')
  // } else {
  //   localStorage.setItem('language', 'en-US')
  // }


  //   if (to.path === "/login") {
  //     next();
  //   } else {
  //     let token = localStorage.getItem("Authorization");

  //     if (token === null || token === "") {
  //       next("/login");
  //     } else {
  //       next();
  //     }
  //   }
  document.body.scrollTop = 0; // firefox
  document.documentElement.scrollTop = 0; // safari
  window.pageYOffset = 0; // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
  next()
});

export default router;
